import { z } from "zod";

import { conditionBuildSchema } from "../../shared/index.ts";

const conditionSlotIdSchema = z.object({
  parentId: z.number().int(),
  name: z.string().optional(), // used in composite condition builders
});

export type ConditionSlotId = z.infer<typeof conditionSlotIdSchema>;

export const addConditionActionSchema = z.object({
  type: z.literal("ADD_CONDITION"),
  payload: z.object({
    condition: conditionBuildSchema,
    to: z.union([
      z.object({ slotId: conditionSlotIdSchema }),
      z.object({ responseId: z.number().int() }),
      z.object({ triggerId: z.number().int() }),
    ]),
  }),
});

export type AddConditionAction = z.infer<typeof addConditionActionSchema>;

export const reorderConditionActionSchema = z.object({
  type: z.literal("REORDER_CONDITION"),
  payload: z.object({
    id: z.number(),
    newIndex: z.number().nonnegative(),
  }),
});

export type ReorderConditionAction = z.infer<typeof reorderConditionActionSchema>;

export const removeConditionActionSchema = z.object({
  type: z.literal("REMOVE_CONDITION"),
  payload: z.object({
    id: z.number(),
  }),
});

export type RemoveConditionAction = z.infer<typeof removeConditionActionSchema>;

export const updateConditionConfigActionSchema = z.object({
  type: z.literal("UPDATE_CONDITION_CONFIG"),
  payload: z.object({
    id: z.number(),
    config: z.record(z.unknown()),
  }),
});

export type UpdateConditionConfigAction = z.infer<typeof updateConditionConfigActionSchema>;

export const moveConditionActionSchema = z.object({
  type: z.literal("MOVE_CONDITION"),
  payload: z.object({
    id: z.number(),
    to: z.object({
      slotId: conditionSlotIdSchema,
      index: z.number().int().nonnegative().optional(),
    }),
  }),
});

export type MoveConditionAction = z.infer<typeof moveConditionActionSchema>;
